import clsx from "clsx";
import { MenuItem as AriaMenuItem } from "react-aria-components";

import { ArrowRightIcon } from "@/assets/icons/general/ArrowRight";
import type { MenuItem as MenuItemType } from "@/components/ui/Menu/Menu";

type MenuListItemProps = MenuItemType;

export const MenuItem = ({ label, content, children, ...item }: MenuListItemProps) => {
  const hasSubmenu = !!children && children?.length > 0;

  return (
    <AriaMenuItem
      {...item}
      textValue={label}
      aria-label={label}
      className={clsx(
        "flex h-9 cursor-pointer items-center justify-between px-2-5 py-2",
        "hover:bg-elevation-surface-2",
        "outline-none",
        "disabled:cursor-default",
        "!text-desktop-body-3",
      )}
      onAction={() => {
        item.onAction?.();
      }}
    >
      {content ?? label}
      {hasSubmenu && <ArrowRightIcon className="!text-interactive-icon-idle size-5" />}
    </AriaMenuItem>
  );
};
